/*
 * Public API Surface of ng-simple-seo
 */

export * from './lib/ng-simple-seo.service';
export * from './lib/ng-simple-seo.component';
export * from './lib/ng-simple-seo.module';
